import { render, staticRenderFns } from "./TitleBox.vue?vue&type=template&id=8fc2a650&scoped=true"
import script from "./TitleBox.vue?vue&type=script&lang=js"
export * from "./TitleBox.vue?vue&type=script&lang=js"
import style0 from "./TitleBox.vue?vue&type=style&index=0&id=8fc2a650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc2a650",
  null
  
)

export default component.exports